// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","455":"7fe8c6c0","578":"5611b94d","977":"9e3561f6"}[chunkId] + ".chunk.js";
};